import { IFormFieldsConfigController } from '../types/IFormFieldsConfigController';

export default (fieldsConfig: IFormFieldsConfigController): void => {
    ($$(fieldsConfig.formConfig.layout.id as string) as webix.ui.window).destructor();
};
